import React, { FunctionComponent } from 'react'
import { Widget } from 'src/components/calendar/Widget'
import { TicketWidget } from 'src/components/calendar/BuyTickets/TicketWidget'

declare var BASE_URL: string

interface Props {
  slug: boolean,
  eventData: any,
  viewer: any,
  listingStatus: string,
  ticketButtonText: string,
  isTimedEntry: boolean,
  loading: boolean,
  isEventSet: boolean,
  expanded: boolean,
}

export const DesktopWidget: FunctionComponent<Props> = ({
  slug,
  eventData,
  loading,
  listingStatus,
  ticketButtonText,
  isTimedEntry,
  isEventSet,
  expanded,
  viewer,
}) => (
  isEventSet && eventData ?
    <Widget slug={slug} eventData={eventData} loading={loading} social /> :
    <TicketWidget
      eventData={eventData}
      expanded={expanded}
      baseUrl={BASE_URL}
      loading={loading}
      ticketButtonText={ticketButtonText}
      listingStatus={listingStatus}
      isTimedEntry={isTimedEntry}
      viewer={viewer}
    />
)
